export default __webpack_public_path__ + "static/media/sensoan_logo.d6e7381d.png";